import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll() {
    return await requestWrapper(null, 'GET', '/classifiers');
  },
  async create(classifier) {
    return await requestWrapper(null, 'POST', '/classifiers', null, classifier);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/classifiers/${id}`);
  },
  async update(classifier) {
    return await requestWrapper(null, 'PUT', `/classifiers/${classifier.id}`, null, classifier);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/classifiers/${id}`);
  },
  async statisticsAll(id) {
    return await requestWrapper(null, 'GET', `/classifiers_statistics/${id}`);
  },
  async statisticsTable(id) {
    return await requestWrapper(null, 'GET', `/classifier_tables_statistics/${id}`);
  },
  async removeLinks(obj) {
    return await requestWrapper(null, 'DELETE', `/classifiers/${obj.classifierId}/documents/${obj.documentId}`);
  },
};
